// 财务管理模块多语言配置
export const finance = {
  'zh-CN': {
    // 财务管理
    financialStatistics: '财务统计',
    moneyManagement: '资金管理',
    moneyRecord: '资金记录',
    moneyForDetails: '资金明细',
    commissionManagement: '佣金管理',
    accountManagement: '账户管理',
    withdrawalRecord: '提现记录',
    personalCommissionDetail: '个人佣金明细',
    viewWithdrawalRecord: '查看提现记录',
    frozenCommission: '冻结佣金',
    
    // 账户管理
    accountManagement: '账户管理',
    withdrawalList: '提现列表',
    
    // 佣金管理
    personalCommission: '个人佣金',
    employeeCommission: '员工佣金',
    commissionSettings: '佣金设置',
    
    // 企业信息
    companyName: '企业名称',
    creditGrantingCompany: '发放额度的企业',
    administrator: '管理员',
    administratorPhone: '管理员电话',
    remainingWithdrawableBalance: '剩余可提现余额',
    
    // 搜索和操作
    startDate: '开始日期',
    endDate: '结束日期',
    search: '搜索',
    export: '导出',
    query: '查询',
    
    // 表格列标题
    serialNumber: '编号',
    commodityIncome: '商品收入',
    commissionExpense: '分销佣金支出',
    corporateServices: '企业服务（支出）',
    operation: '操作',
    details: '详情',
    
    // 记录类型
    orderSalesNew: '订单销售新增',
    commissionDeduction: '佣金扣减',
    withdrawal: '提现',
    withdrawalFailedReturn: '提现失败退回',
    
    // 表格列标题
    occurrenceTime: '发生时间',
    recordType: '记录类型',
    balanceChange: '余额变化',
    balance: '余额',
    orderNumber: '订单编号',
    applicationTime: '申请时间',
    applicationAmount: '申请金额',
    withdrawableAmount: '可提现金额',
    withdrawalAccount: '提现账户',
    remarkDescription: '备注描述',
    paymentTime: '打款时间',
    status: '状态',
    
    // 状态
    waitingForPayment: '等待打款',
    paymentSuccessful: '打款成功',
    rejected: '已驳回',
    approvedPendingPayment: '审核通过待打款',
    
    // 筛选状态
    all: '全部',
    
    // 用户信息
    userInfo: '用户信息',
    sequenceNumber: '序号',
    avatar: '头像',
    name: '名称',
    contactInfo: '联系方式',
    totalSuccessfulOrders: '总成交单数',
    totalOrderAmount: '总订单金额(港元)',
    totalCommission: '总佣金(港元)',
    withdrawableCommission: '可提现佣金(港元)',
    withdrawingCommission: '提现中的佣金(港元)',
    withdrawnCommission: '已提现佣金(港元)',
    
    // 佣金详情
    commissionDetailNumber: '佣金详情编号',
    orderRealPaymentAmount: '订单实付金额',
    commissionRate: '佣金比例',
    availableCommission: '可得佣金',
    orderCompletionTime: '订单完成时间',
    
    // 财务统计
    totalIncome: '总收入',
    totalExpense: '总支出',
    netIncome: '淨收入',
    commissionIncome: '佣金收入',
    withdrawalAmount: '提现金额',
    pendingAmount: '待处理金额',
    accountBalance: '账户余额',
    
    // 资金管理
    recharge: '充值',
    withdraw: '提现',
    transfer: '转账',
    freeze: '冻结',
    unfreeze: '解冻',
    
    // 记录类型
    income: '收入',
    expense: '支出',
    commission: '佣金',
    refund: '退款',
    
    // 新增的文本
    totalRevenue: '收入合计',
    totalRevenueTip: '累计商品收入-累计分销佣金支出',
    cumulativeProductIncome: '累计商品收入',
    cumulativeCommissionExpense: '累计分销佣金支出',
    remainingWithdrawableCommission: '剩余可提现佣金',
    companyNameOrPhone: '企业名称/管理员电话',
    companyId: '编号',
    totalPay: '商品收入',
    commission: '分销佣金支出',
    
    // 资金管理相关
    commodityIncome: '商品收入',
    corporateServices: '企业服务（支出）',
    
    // 佣金设置
    commissionSettlementCycle: '佣金入账周期设置',
    orderCompletedDays: '订单状态变为"已完成"后',
    days: '天',
    commissionWithdrawalLimit: '佣金提现额度设置',
    withdrawalAmountLimit: '佣金提现金额满',
    yuan: '港元',
    save: '保存',
    saveTip: '提示：保存后即时生效，分销佣金都按照本设置入账',
    pleaseConfigureCommissionSettings: '请先配置佣金设置参数',
    
    // 员工佣金
    selectDate: '选择日期',
    employeeName: '请输入员工姓名',
    department: '部门',
    totalCommission: '总佣金',
    withdrawableCommission: '可提现佣金（港元）',
    withdrawingCommission: '提现中佣金（港元）',
    withdrawnCommission: '已提现佣金',
    
    // 提现列表
    userName: '请输入用户/员工姓名',
    phoneNumber: '请输入手机号',
    withdrawalTime: '提现时间',
    orderStatus: '订单状态',
    userCategory: '用户类别',
    employee: '员工',
    normal: '普通',
    withdrawalAmount: '提现金额（港元）',
    userType: '用户类别',
    approvalTime: '审核时间',
    confirm: '确认',
    reject: '驳回',
    confirmTip: '确认',
    rejectTip: '驳回',
    operationSuccess: '操作成功！',
    
    // 提现设置
    withdrawalSettings: '提现设置',
    minimumWithdrawalStandard: '提现最低标准设置：企业余额最低提现金额为',
    minimumWithdrawalTip: '港元。(微信提现要求至少0.3港元)',
    paymentMethodSettings: '打款方式设置：是否开启自动打款',
    autoPaymentSettingsTip: '（开启即表示企业余额提现时，无需审核，提现金额自动到达企业BOSS微信账户上）',
    withdrawalList: '提现列表',
    receiptAccount: '收款账户',
    withdrawalAmountYuan: '提现金额（港元）',
    applicationTime: '申请时间',
    approvalRejectionTime: '打款/驳回时间',
    remarks: '备注',
    waitingForPayment: '等待打款',
    paymentSuccessful: '打款成功',
    rejected: '已驳回',
    approvedPendingPayment: '审核通过待打款',
    openRejectBox: '请输入驳回理由',
    rejectReason: '驳回理由',
    rejectReasonRequired: '驳回理由不能为空',
    cancelInput: '取消输入',
    cancelInputTip: '已取消',
    operationIrreversible: '此操作不可逆，确认继续打款',
    withdrawal: '打款',
    confirmContinue: '确认继续',
    cancel: '取消',
    
    // 时间单位
    second: '秒',
    minute: '分',
    hour: '小时',
    
    // 货币单位
    yuan: '港元',
    
    // 信用额度记录
    creditRecord: '信用额度记录',
    recordTime: '记录时间',
    changeType: '变化类型',
    changeAmount: '变化金额',
    balanceBefore: '变化前余额',
    balanceAfter: '变化后余额',
    relatedOrder: '关联订单',
    remark: '备注',
    companyNamePlaceholder: '请输入企业名称',
    fetchRecordsFailed: '获取记录失败',
    changeTypePurchase: '购买',
    changeTypeRefund: '退款',
    changeTypeAdjust: '调整'
  },
  'zh-TW': {
    // 財務管理
    financialStatistics: '財務統計',
    moneyManagement: '資金管理',
    moneyRecord: '資金記錄',
    moneyForDetails: '資金明细',
    commissionManagement: '佣金管理',
    accountManagement: '賬戶管理',
    withdrawalRecord: '提現記錄',
    personalCommissionDetail: '個人佣金明细',
    viewWithdrawalRecord: '查看提現記錄',
    frozenCommission: '凍結佣金',
    
    // 賬戶管理
    accountManagement: '賬戶管理',
    withdrawalList: '提現列表',
    
    // 佣金管理
    personalCommission: '個人佣金',
    employeeCommission: '員工佣金',
    commissionSettings: '佣金設置',
    
    // 企業信息
    companyName: '企業名稱',
    creditGrantingCompany: '發放額度的企業',
    administrator: '管理員',
    administratorPhone: '管理員電話',
    remainingWithdrawableBalance: '剩餘可提現餘額',
    
    // 搜索和操作
    startDate: '開始日期',
    endDate: '結束日期',
    search: '搜索',
    export: '導出',
    query: '查詢',
    
    // 表格列標題
    serialNumber: '編號',
    commodityIncome: '商品收入',
    commissionExpense: '分銷佣金支出',
    corporateServices: '企業服務（支出）',
    operation: '操作',
    details: '詳情',
    
    // 記錄類型
    orderSalesNew: '訂單銷售新增',
    commissionDeduction: '佣金扣減',
    withdrawal: '提現',
    withdrawalFailedReturn: '提現失敗退回',
    
    // 表格列標題
    occurrenceTime: '發生時間',
    recordType: '記錄類型',
    balanceChange: '餘額變化',
    balance: '餘額',
    orderNumber: '訂單編號',
    applicationTime: '申請時間',
    applicationAmount: '申請金額',
    withdrawableAmount: '可提現金額',
    withdrawalAccount: '提現賬戶',
    remarkDescription: '備註描述',
    paymentTime: '打款時間',
    status: '狀態',
    
    // 狀態
    waitingForPayment: '等待打款',
    paymentSuccessful: '打款成功',
    rejected: '已駁回',
    approvedPendingPayment: '審核通過待打款',
    
    // 篩選狀態
    all: '全部',
    
    // 用戶信息
    userInfo: '用戶信息',
    sequenceNumber: '序號',
    avatar: '頭像',
    name: '名稱',
    contactInfo: '聯繫方式',
    totalSuccessfulOrders: '總成交單數',
    totalOrderAmount: '總訂單金額(港元)',
    totalCommission: '總佣金(港元)',
    withdrawableCommission: '可提現佣金(港元)',
    withdrawingCommission: '提現中的佣金(港元)',
    withdrawnCommission: '已提現佣金(港元)',
    
    // 佣金詳情
    commissionDetailNumber: '佣金詳情編號',
    orderRealPaymentAmount: '訂單實付金額',
    commissionRate: '佣金比例',
    availableCommission: '可得佣金',
    orderCompletionTime: '訂單完成時間',
    
    // 財務統計
    totalIncome: '總收入',
    totalExpense: '總支出',
    netIncome: '淨收入',
    commissionIncome: '佣金收入',
    withdrawalAmount: '提現金額',
    pendingAmount: '待處理金額',
    accountBalance: '賬戶餘額',
    
    // 資金管理
    recharge: '充值',
    withdraw: '提現',
    transfer: '轉賬',
    freeze: '凍結',
    unfreeze: '解凍',
    
    // 記錄類型
    income: '收入',
    expense: '支出',
    commission: '佣金',
    refund: '退款',
    
    // 新增的文本
    totalRevenue: '收入合計',
    totalRevenueTip: '累計商品收入-累計分銷佣金支出',
    cumulativeProductIncome: '累計商品收入',
    cumulativeCommissionExpense: '累計分銷佣金支出',
    remainingWithdrawableCommission: '剩餘可提現佣金',
    companyNameOrPhone: '企業名稱/管理員電話',
    companyId: '編號',
    totalPay: '商品收入',
    commission: '分銷佣金支出',
    
    // 佣金設置
    commissionSettlementCycle: '佣金入賬週期設置',
    orderCompletedDays: '訂單狀態變為"已完成"後',
    days: '天',
    commissionWithdrawalLimit: '佣金提現額度設置',
    withdrawalAmountLimit: '佣金提現金額滿',
    yuan: '港元',
    save: '保存',
    saveTip: '提示：保存後即時生效，分銷佣金都按照本設置入賬',
    pleaseConfigureCommissionSettings: '請先配置佣金設置參數',
    
    // 員工佣金
    selectDate: '選擇日期',
    employeeName: '請輸入員工姓名',
    department: '部門',
    totalCommission: '總佣金',
    withdrawableCommission: '可提現佣金（港元）',
    withdrawingCommission: '提現中佣金（港元）',
    withdrawnCommission: '已提現佣金',
    
    // 提現列表
    userName: '請輸入用戶/員工姓名',
    phoneNumber: '請輸入手機號',
    withdrawalTime: '提現時間',
    orderStatus: '訂單狀態',
    userCategory: '用戶類別',
    employee: '員工',
    normal: '普通',
    withdrawalAmount: '提現金額（港元）',
    userType: '用戶類別',
    approvalTime: '審核時間',
    confirm: '確認',
    reject: '駁回',
    confirmTip: '確認',
    rejectTip: '駁回',
    operationSuccess: '操作成功！',
    
    // 提現設置
    withdrawalSettings: '提現設置',
    minimumWithdrawalStandard: '提現最低標準設置：企業餘額最低提現金額為',
    minimumWithdrawalTip: '港元。(微信提現要求至少0.3港元)',
    paymentMethodSettings: '打款方式設置：是否開啟自動打款',
    autoPaymentSettingsTip: '（開啟即表示企業餘額提現時，無需審核，提現金額自動到達企業BOSS微信賬戶上）',
    withdrawalList: '提現列表',
    receiptAccount: '收款賬戶',
    withdrawalAmountYuan: '提現金額（港元）',
    applicationTime: '申請時間',
    approvalRejectionTime: '打款/駁回時間',
    remarks: '備註',
    waitingForPayment: '等待打款',
    paymentSuccessful: '打款成功',
    rejected: '已駁回',
    approvedPendingPayment: '審核通過待打款',
    openRejectBox: '請輸入駁回理由',
    rejectReason: '駁回理由',
    rejectReasonRequired: '駁回理由不能為空',
    cancelInput: '取消輸入',
    cancelInputTip: '已取消',
    operationIrreversible: '此操作不可逆，確認繼續打款',
    withdrawal: '打款',
    confirmContinue: '確認繼續',
    cancel: '取消',
    
    // 時間單位
    second: '秒',
    minute: '分',
    hour: '小時',
    
    // 貨幣單位
    yuan: '港元',
    
    // 信用額度記錄
    creditRecord: '信用額度記錄',
    recordTime: '記錄時間',
    changeType: '變化類型',
    changeAmount: '變化金額',
    balanceBefore: '變化前餘額',
    balanceAfter: '變化後餘額',
    relatedOrder: '關聯訂單',
    remark: '備註',
    companyNamePlaceholder: '請輸入企業名稱',
    fetchRecordsFailed: '獲取記錄失敗',
    changeTypePurchase: '購買',
    changeTypeRefund: '退款',
    changeTypeAdjust: '調整'
  },
  'en': {
    // Financial Management
    financialStatistics: 'Financial Statistics',
    moneyManagement: 'Money Management',
    moneyRecord: 'Money Record',
    moneyForDetails: 'Money Details',
    commissionManagement: 'Commission Management',
    accountManagement: 'Account Management',
    withdrawalRecord: 'Withdrawal Record',
    personalCommissionDetail: 'Personal Commission Detail',
    viewWithdrawalRecord: 'View Withdrawal Record',
    frozenCommission: 'Frozen',

    
    // Account Management
    accountManagement: 'Account Management',
    withdrawalList: 'Withdrawal List',
    
    // Commission Management
    personalCommission: 'Personal Commission',
    employeeCommission: 'Employee Commission',
    commissionSettings: 'Commission Settings',
    
    // Company Information
    companyName: 'Company Name',
    creditGrantingCompany: 'Credit Granting Company',
    administrator: 'Administrator',
    administratorPhone: 'Administrator Phone',
    remainingWithdrawableBalance: 'Remaining Withdrawable Balance',
    
    // Search and Operations
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    export: 'Export',
    query: 'Query',
    
    // Table Column Headers
    serialNumber: 'Serial Number',
    commodityIncome: 'Commodity Income',
    commissionExpense: 'Commission Expense',
    corporateServices: 'Corporate Services (Expense)',
    operation: 'Operation',
    details: 'Details',
    
    // Record Types
    orderSalesNew: 'Order Sales New',
    commissionDeduction: 'Commission Deduction',
    withdrawal: 'Withdrawal',
    withdrawalFailedReturn: 'Withdrawal Failed Return',
    
    // Table Column Headers
    occurrenceTime: 'Occurrence Time',
    recordType: 'Record Type',
    balanceChange: 'Balance Change',
    balance: 'Balance',
    orderNumber: 'Order Number',
    applicationTime: 'Application Time',
    applicationAmount: 'Application Amount',
    withdrawableAmount: 'Withdrawable Amount',
    withdrawalAccount: 'Withdrawal Account',
    remarkDescription: 'Remark Description',
    paymentTime: 'Payment Time',
    status: 'Status',
    
    // Status
    waitingForPayment: 'Waiting for Payment',
    paymentSuccessful: 'Payment Successful',
    rejected: 'Rejected',
    approvedPendingPayment: 'Approved Pending Payment',
    
    // Filter Status
    all: 'All',
    
    // User Information
    userInfo: 'User Information',
    sequenceNumber: 'Sequence Number',
    avatar: 'Avatar',
    name: 'Name',
    contactInfo: 'Contact Info',
    totalSuccessfulOrders: 'Total Successful Orders',
    totalOrderAmount: 'Total Order Amount (¥)',
    totalCommission: 'Total Commission (¥)',
    withdrawableCommission: 'Withdrawable Commission (¥)',
    withdrawingCommission: 'Withdrawing Commission (¥)',
    withdrawnCommission: 'Withdrawn Commission (¥)',
    
    // Commission Details
    commissionDetailNumber: 'Commission Detail Number',
    orderRealPaymentAmount: 'Order Real Payment Amount',
    commissionRate: 'Commission Rate',
    availableCommission: 'Available Commission',
    orderCompletionTime: 'Order Completion Time',
    
    // Financial Statistics
    totalIncome: 'Total Income',
    totalExpense: 'Total Expense',
    netIncome: 'Net Income',
    commissionIncome: 'Commission Income',
    withdrawalAmount: 'Withdrawal Amount',
    pendingAmount: 'Pending Amount',
    accountBalance: 'Account Balance',
    
    // Money Management
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    transfer: 'Transfer',
    freeze: 'Freeze',
    unfreeze: 'Unfreeze',
    
    // Record Types
    income: 'Income',
    expense: 'Expense',
    commission: 'Commission',
    refund: 'Refund',
    
    // New text
    totalRevenue: 'Total Revenue',
    totalRevenueTip: 'Cumulative product income - Cumulative commission expense',
    cumulativeProductIncome: 'Cumulative Product Income',
    cumulativeCommissionExpense: 'Cumulative Commission Expense',
    remainingWithdrawableCommission: 'Remaining Withdrawable Commission',
    companyNameOrPhone: 'Company Name/Administrator Phone',
    companyId: 'Company ID',
    totalPay: 'Product Income',
    commission: 'Commission Expense',
    
    // Commission Settings
    commissionSettlementCycle: 'Commission Settlement Cycle Settings',
    orderCompletedDays: 'After order status becomes "Completed"',
    days: 'days',
    commissionWithdrawalLimit: 'Commission Withdrawal Limit Settings',
    withdrawalAmountLimit: 'Commission withdrawal amount must reach',
    yuan: 'HK$',
    save: 'Save',
    saveTip: 'Note: Takes effect immediately after saving, all distribution commissions will be settled according to these settings',
    pleaseConfigureCommissionSettings: 'Please configure commission settings first',
    
    // Employee Commission
    selectDate: 'Select Date',
    employeeName: 'Please enter employee name',
    department: 'Department',
    totalCommission: 'Total Commission',
    withdrawableCommission: 'Withdrawable Commission (¥)',
    withdrawingCommission: 'Withdrawing Commission (¥)',
    withdrawnCommission: 'Withdrawn Commission',
    
    // Withdrawal List
    userName: 'Please enter user/employee name',
    phoneNumber: 'Please enter phone number',
    withdrawalTime: 'Withdrawal Time',
    orderStatus: 'Order Status',
    userCategory: 'User Category',
    employee: 'Employee',
    normal: 'Normal',
    withdrawalAmount: 'Withdrawal Amount (¥)',
    userType: 'User Type',
    approvalTime: 'Approval Time',
    confirm: 'Confirm',
    reject: 'Reject',
    confirmTip: 'Confirm',
    rejectTip: 'Reject',
    operationSuccess: 'Operation Successful!',
    
    // Withdrawal Settings
    withdrawalSettings: 'Withdrawal Settings',
    minimumWithdrawalStandard: 'Minimum withdrawal standard setting: Minimum withdrawal amount for enterprise balance is',
    minimumWithdrawalTip: 'Yuan. (WeChat withdrawal requires at least 0.3 yuan)',
    paymentMethodSettings: 'Payment method setting: Whether to enable automatic payment',
    autoPaymentSettingsTip: '(Enabling means that when enterprise balance is withdrawn, no review is required, and withdrawal amount automatically reaches the enterprise BOSS WeChat account)',
    withdrawalList: 'Withdrawal List',
    receiptAccount: 'Receipt Account',
    withdrawalAmountYuan: 'Withdrawal Amount (¥)',
    applicationTime: 'Application Time',
    approvalRejectionTime: 'Payment/Rejection Time',
    remarks: 'Remarks',
    waitingForPayment: 'Waiting for Payment',
    paymentSuccessful: 'Payment Successful',
    rejected: 'Rejected',
    approvedPendingPayment: 'Approved Pending Payment',
    openRejectBox: 'Please enter rejection reason',
    rejectReason: 'Rejection Reason',
    rejectReasonRequired: 'Rejection reason cannot be empty',
    cancelInput: 'Cancel Input',
    cancelInputTip: 'Cancelled',
    operationIrreversible: 'This operation is irreversible, confirm to continue payment',
    withdrawal: 'Withdrawal',
    confirmContinue: 'Confirm Continue',
    cancel: 'Cancel',
    
    // Time Units
    second: 'second',
    minute: 'minute',
    hour: 'hour',
    
    // Currency Units
    yuan: 'HK$',
    
    // Credit Record
    creditRecord: 'Credit Record',
    recordTime: 'Record Time',
    changeType: 'Change Type',
    changeAmount: 'Change Amount',
    balanceBefore: 'Balance Before',
    balanceAfter: 'Balance After',
    relatedOrder: 'Related Order',
    remark: 'Remark',
    companyNamePlaceholder: 'Please enter company name',
    fetchRecordsFailed: 'Failed to fetch records',
    changeTypePurchase: 'Purchase',
    changeTypeRefund: 'Refund',
    changeTypeAdjust: 'Adjustment'
  }
}; 